import { render, staticRenderFns } from "./ServidoresSuporte.vue?vue&type=template&id=425c85da&"
import script from "./ServidoresSuporte.vue?vue&type=script&lang=js&"
export * from "./ServidoresSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports